export enum PriorityTypes {
  GENERAL = 0,
  SUBDIVISION = 1,
  USERLOCAL = 2
}
